import _ from 'lodash';

import { MimeTypeBase, MPCMimeType } from '../../types/entities';
import { stringToStringEnum } from '../enum';

export function toMimeType(str: string | null | undefined): MPCMimeType {
  const [mimeType, suffix] = (str || '').split('/');

  return {
    type: stringToStringEnum<MimeTypeBase>(MimeTypeBase, _.toLower(mimeType)),
    suffix: suffix ? _.toLower(suffix) : undefined,
  };
}
